<template>
  <div
    v-if="path[0] === getPathText() && loadingChecklistReportData"
    class="tw-ml-[10px] custom-global-skeleton tw-w-[250px] tw-h-full tw-rounded-[6px]"
  ></div>
  <div v-else class="active-path-header">
    <div
      v-for="(item, index) in path"
      :key="index"
      :class="`parent ${
        index === path.length - 1 || !path[index + 1] ? 'active' : ''
      }`"
    >
      <a
        v-if="navigate && navigate[index] && navigate[index].length > 0"
        :href="navigate[index]"
        :class="'active-navigate'"
        @click.prevent="handleNavigate(index)"
      >
        {{ item }}
      </a>

      <span v-else>
        {{ item }}
      </span>

      <span v-if="index !== path.length - 1 && path[index + 1]" class="circle"
        >•</span
      >
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";

@Component({
  components: {},
})
export default class ActivePathHeader extends Vue {
  @Prop({ required: true }) readonly path: Array<string> = [];
  @Prop({ required: false, default: [] }) readonly navigate: Array<string> = [];

  get loadingChecklistReportData() {
    return store.state.Sharing.isLoading;
  }

  getPathText() {
    return getComponentUiText("app-menu-submenu-share-cyber-health-report-1");
  }

  handleNavigate(index: number) {
    if (this.navigate && this.navigate[index]) {
      this.$router.push({
        path: this.navigate[index],
      });
    }
  }
}
</script>

<style scoped>
.active-path-header {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.active-path-header .parent {
  /* text/text-13_med */

  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  /* identical to box height */

  /* brand/Dark Sky */

  color: #211f58;

  display: flex;
  align-items: center;
  gap: 15px;
}

.active-path-header .active {
  font-weight: 400;
  color: #878787;
}

.active-path-header .active-navigate {
  color: #211f58;
}

.active-path-header .active-navigate:hover {
  cursor: pointer;
  text-decoration: underline;
}

.active-path-header .circle {
  width: 4px;
  height: 13px;
  color: #878787;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .active-path-header .parent {
    font-size: 11px;
  }
}

@media (max-width: 430px) {
  .active-path-header {
    gap: 5px;
  }

  .active-path-header .parent {
    gap: 5px;
  }
}
</style>
